import { Loader2 } from 'lucide-react'
import { cn } from '@/internationalization/cn'

export function Spinner({
  size = 'md',
  label = 'Loading',
  className,
}: {
  size?: 'sm' | 'md' | 'lg'
  label?: string
  className?: string
}) {
  const dims = { sm: 'h-4 w-4', md: 'h-5 w-5', lg: 'h-8 w-8' }[size]
  return (
    <span role="status" aria-label={label} className={cn('inline-flex text-fg-subtle', className)}>
      <Loader2 aria-hidden className={cn('animate-spin', dims)} />
    </span>
  )
}
